// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2026-05-12T12:07:45+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  192125
//    Project:        617
//    Environment:    7626 - master
//    MD5:            1454084009ebf6ee7da45c3ec95efae2
//    Signature:      eyJpdiI6IjQrQmNqRGprZWhvclpzUFBodGxCQmc9PSIsInZhbHVlIjoiU2cxWE5ZUTVXT2lFNTNlYkFKM25MTEdPRFd3NlFnUWpcL3ZobXVnMzNMWk03ZUVVOWhyMmN4SDNNWnREd2RDUGlJTDJGaXEydGlMbVVMVStlNkpWRWE1cENvZUExNmR5dWhMR3F3cVBDUXk4dmkydEFlbmxLVkkxOHJqdERzNytTUzhqYWdhUmt6clJtVXJVS3k0NEhBaThYalFMMUYxQ0FMdjlNZStlN1oyQ0JUU0daT1NLT2Q2Z042ZDNtYnhKVXo1Z2xCNTFUXC9hMmhnUUdtNk9nVnBseHFCQ0t5XC8xQ1dNRnUyUkUrXC85WnBCZkFYc3JIM2VnY2xHdVhvbXo5Q1R3ODdQVEFsc0FVQ2dHRm9PaFBiZG0rWm0xNllQYjlHSmdOVzRncGhlTXNENXhuemt3SGljaVk2U0xmeExCRVU4Sk5pWG9TWWhLXC9oMFhwcUZWb2Q4Tnd4UjV5bzZibjJuQ3FKR0U2XC8rY3FVWmpSOXJrMGxSRHpTQklibmhMV0pnWDdpcU1zbVNzdXFjK2UyeFhvRGUrNmFSWUJkeGYrWENMdUpxdXVHTHVmdz0iLCJtYWMiOiJhM2NkM2EwZTBkYzEwNzA2YjQyNTU0ZjNkZDNmYmY2MjUyNzc5OGIwYzc5NTFjODNlOGY0ZDMxMmRmOGIyN2EzIn0=
class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
